import { apiFetch, ApiBaseUrl } from "./fetch";

export default class ApiClientActions {
  static getActions(appId) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/client_actions`);
  }

  static updateAction(appId, actionId, action) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/client_actions/${actionId}`, {
      method: "PUT",
      body: { client_action: action },
    });
  }

  static createAction(appId, action) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/client_actions`, {
      method: "POST",
      body: { client_action: action },
    });
  }

  static async deleteAction(appId, actionId) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/client_actions/${actionId}`, {
      method: "DELETE",
    }).then(_ => actionId);
  }
}
